import { render } from "./stage5.vue?vue&type=template&id=16f23bcc&scoped=true"
import script from "./stage5.vue?vue&type=script&lang=js"
export * from "./stage5.vue?vue&type=script&lang=js"

import "./stage5.vue?vue&type=style&index=0&id=16f23bcc&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/_DKRx8o2/0/web/speechki_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f23bcc"]])

export default __exports__